__turbopack_context__.v({
  "contentWrapper": "R2iD9W_contentWrapper",
  "description": "R2iD9W_description",
  "divider": "R2iD9W_divider",
  "featureDescription": "R2iD9W_featureDescription",
  "featureItem": "R2iD9W_featureItem",
  "featureList": "R2iD9W_featureList",
  "featureTitle": "R2iD9W_featureTitle",
  "header": "R2iD9W_header",
  "heading": "R2iD9W_heading",
  "leftColumn": "R2iD9W_leftColumn",
  "rightColumn": "R2iD9W_rightColumn",
  "section": "R2iD9W_section",
  "therapyVideo": "R2iD9W_therapyVideo",
  "videoFrame": "R2iD9W_videoFrame",
});
